export const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
};

export const googleCloudKeyfileConfig = JSON.parse(
  Buffer.from(process.env.NEXT_PUBLIC_GOOGLE_CLOUD_KEYFILE, "base64").toString()
);

export const gtmConfig = {
  // containerId: process.env.NEXT_PUBLIC_GTM_CONTAINER_ID
  containerId: "GTM-PQHPJTKH", // Hardcoded for now, replace with env variable if needed
};

export const googleCalendarClientId =
  process.env.NEXT_PUBLIC_GOOGLE_CALENDAR_CLIENT_ID;
export const googleCalendarApiKey =
  process.env.NEXT_PUBLIC_GOOGLE_CALENDAR_API_KEY;

export const discountCodeKey =
  "V7XF97Q1OTKUZ0JSBV7PLD7D41Y6DMCSXWR5GM5IK43OJCGOCR";

export const mysqlConfig = {
  host: process.env.NEXT_PRIVATE_MYSQL_HOST,
  port: process.env.NEXT_PRIVATE_MYSQL_PORT,
  database: process.env.NEXT_PRIVATE_MYSQL_DATABASE,
  user: process.env.NEXT_PRIVATE_MYSQL_USER,
  password: process.env.NEXT_PRIVATE_MYSQL_PASSWORD,
};

export const totpSecret = process.env.NEXT_PRIVATE_TOTP_SECRET;

export const telegramBotToken = process.env.NEXT_PRIVATE_TELEGRAM_BOT_TOKEN;

// Cloudflare R2
export const cloudflareR2 = {
  accountId: process.env.NEXT_PUBLIC_CLOUDFLARE_R2_ACCOUNT_ID,
  bucket: "crm-elam",
  publicDomain: process.env.NEXT_PUBLIC_CLOUDFLARE_R2_PUBLIC_DOMAIN, // <- sin /crm-elam
  accessKeyId: process.env.CLOUDFLARE_R2_ACCESS_KEY_ID,
  secretAccessKey: process.env.CLOUDFLARE_R2_SECRET_ACCESS_KEY,
};

// Cloudflare images
export const cloudflareImages = {
  token: process.env.CLOUDFLARE_IMAGES_API_KEY,
  accountId: process.env.CLOUDFLARE_IMAGES_ACCOUNT_ID,
  baseUrl: `https://api.cloudflare.com/client/v4/accounts/${process.env.CLOUDFLARE_IMAGES_ACCOUNT_ID}/images/v1`,
};

// Algolia
export const algoliaPublic = {
  appId: process.env.NEXT_PUBLIC_ALGOLIA_APP_ID,
  searchKey: process.env.ALGOLIA_SEARCH_KEY,
};
